import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/styles/global.less';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import BaiduMap from 'vue-baidu-map';
import scroll from 'vue-seamless-scroll';
import ba from 'vue-ba';

// Vue.use(ba, '5195ec999dc167b8e5373b74f849b2d6');

Vue.use(BaiduMap, {
    ak: 'ZloX8IDtVIs68WLCmYz1tXvkA6N0Lene'
});

Vue.use(ElementUI);

Vue.use(scroll);

Vue.use(VueAwesomeSwiper);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
